import React, { useContext, useEffect } from 'react';
import { useAdtopiaLoadApi } from '../Hooks/useAdtopiaLoadApi';
import { AppDomainWithoutProtocol, AppDomain, AppLpDefaultUrl, AppApDefaultUrl, AppAdtopiaUPID, AppReferrerURL } from "../Constants/EnvConstants";
import { getQueryString } from "../Utility/QueryString";
import { UUID } from "./UUID";
import { useHistory } from "react-router-dom";
import { CheckRedirectUrl } from "../Utility/CheckRedirectUrl";
import RedirectContext from "../Contexts/RedirectContext";
import {defaultDomainLp} from "../Constants/DefaultDomainLp";
import { getBuyerName } from "../Components/Includes/Layouts/Common/BuyerBasedOnDomain";

const AdtopiaLoadRoot = ({ splitName }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const history = useHistory();
  const encryptVal = urlParams.get('value');
  const { getUUID } = UUID();
  const { adtopiaLoadResponse, adtopiaLoadingErr } = useAdtopiaLoadApi();
  const { redirectUrl } = useContext(RedirectContext);
  const { isLpUrlExist } = CheckRedirectUrl();
  const field = 'uuid';
  var redirectURL = "";
  var url = "";
  var queryString = getQueryString();
  const {brand,b_id} = getBuyerName() ?? '';
  useEffect(() => {
    (async () => {
      let uuidType = 'new';
      const getUUIDParam = await getUUID(
        splitName,
        uuidType
      );
      if(queryString == ""){
        url = AppDomain;
      }else{
        url = AppDomain + '?' + queryString;
      }
      const uuid = getUUIDParam;
      const getdtopiaApi = await adtopiaLoadResponse(
        url,
        AppDomainWithoutProtocol,
        window.navigator.userAgent,
        uuid,
        AppAdtopiaUPID,
        AppReferrerURL
      );
      const rediretDefaultDomainLp = defaultDomainLp?.[AppDomainWithoutProtocol] ? defaultDomainLp[AppDomainWithoutProtocol] : AppLpDefaultUrl;
      if (adtopiaLoadingErr) {
        history.push('/' + rediretDefaultDomainLp + '?uuid=' + uuid);
      }
      if (typeof getdtopiaApi !== "undefined") {
        const getdtopiaApiResponse = getdtopiaApi.data;
       if (typeof getdtopiaApiResponse.url_param === 'string' && getdtopiaApiResponse.url_param.trim() !== ''
        ) {
          const urlParamsObj = new URLSearchParams(getdtopiaApiResponse.url_param);
          const brandValue = urlParamsObj.get('b_id');
          if (!urlParamsObj.has('b_id') || !brandValue) {
            urlParamsObj.set('b_id', b_id);
          }
          getdtopiaApiResponse.url_param = urlParamsObj.toString();
        }
        if (getdtopiaApiResponse.page_type == 'advertorial') {
          if (getdtopiaApiResponse.lp_url) {
            redirectURL = getdtopiaApiResponse.lp_url;
          } else {
            redirectURL = await isLpUrlExist();
          }
          redirectUrl.redirectUrl = redirectURL;
          if (getdtopiaApiResponse.response === 200) {
            if (getdtopiaApiResponse.domain_name === AppDomainWithoutProtocol) {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param /*+ '&lp_url=' + redirectURL*/);
              } else {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid /*+ '&lp_url=' + redirectURL*/);
              }
            } else {
              window.location.href = getdtopiaApiResponse.url + '&uuid=' + uuid /*+ '&lp_url=' + redirectURL*/;
            }
          } else if (getdtopiaApiResponse.response === 404) {
            if (getdtopiaApiResponse.url_param != "") {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + AppApDefaultUrl + '?' + getdtopiaApiResponse.url_param /*+ '&lp_url=' + redirectURL*/);
              } else {
                history.push('/' + AppApDefaultUrl + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid /*+ '&lp_url=' + redirectURL*/);
              }
            } else {
              history.push('/' + AppApDefaultUrl + '?uuid=' + uuid /*+ '&lp_url=' + redirectURL*/);
            }
          } else {
            if (getdtopiaApiResponse.url_param != "") {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + AppApDefaultUrl + '?' + getdtopiaApiResponse.url_param /*+ '&lp_url=' + redirectURL*/);
              } else {
                history.push('/' + AppApDefaultUrl + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid /*+ '&lp_url=' + redirectURL*/);
              }
            } else {
              history.push('/' + AppApDefaultUrl + '?uuid=' + uuid /*+ '&lp_url=' + redirectURL*/);
            }
          }
        }
        else if (getdtopiaApiResponse.page_type == 'landingpage') {
          if (getdtopiaApiResponse.response === 200) {
            if (getdtopiaApiResponse.domain_name === AppDomainWithoutProtocol) {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param + '&crvid=' + getdtopiaApiResponse.crvid);
              } else {
                history.push('/' + getdtopiaApiResponse.split_full_name + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid + '&crvid=' + getdtopiaApiResponse.crvid);
              }
            } else {
              window.location.href = getdtopiaApiResponse.url + '&uuid=' + uuid + '&crvid=' + getdtopiaApiResponse.crvid + '&b_id=' + b_id;
            }
          } else if (getdtopiaApiResponse.response === 404) {
            if (getdtopiaApiResponse.url_param != "") {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + rediretDefaultDomainLp + '?' + getdtopiaApiResponse.url_param + '&crvid=' + getdtopiaApiResponse.crvid);
              } else {
                history.push('/' + rediretDefaultDomainLp + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid + '&crvid=' + getdtopiaApiResponse.crvid);
              }
            } else {
              history.push('/' + rediretDefaultDomainLp + '?uuid=' + uuid + '&b_id=' + b_id);
            }
          } else {
            if (getdtopiaApiResponse.url_param != "") {
              if (getdtopiaApiResponse.url_param.indexOf('&' + field + '=') != -1) {
                history.push('/' + rediretDefaultDomainLp + '?' + getdtopiaApiResponse.url_param + '&crvid=' + getdtopiaApiResponse.crvid);
              } else {
                history.push('/' + rediretDefaultDomainLp + '?' + getdtopiaApiResponse.url_param + '&uuid=' + uuid + '&crvid=' + getdtopiaApiResponse.crvid);
              }
            } else {
              history.push('/' + rediretDefaultDomainLp + '?uuid=' + uuid + '&b_id=' + b_id);
            }
          }
        } else {
          history.push('/' + rediretDefaultDomainLp + '?uuid=' + uuid + '&b_id=' + b_id);
        }
      } else {
        redirectURL = rediretDefaultDomainLp;
        history.push('/' + rediretDefaultDomainLp + '?uuid=' + uuid + '&b_id=' + b_id);
      }
      localStorage.setItem('redirectURL', redirectURL);
    })()
  }, [])
  return (
    <></>
  )
}

export default AdtopiaLoadRoot;